import React, { Fragment, useState } from 'react';
import Header from '../../Components/Header';
import './Index.scss';
import Input from '../../Components/Input';
import { Link } from 'react-router-dom';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [currentEmployer, setCurrentEmployer] = useState('');
  const [isValidForm, setFormState] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
    setFormState(!email && !password && !currentEmployer);
  };

  return (
    <main>
      <Fragment>
        <Header />
        <section className="container mb-auto auth-section">
          <h1 className="display-4 text-center">Register</h1>
          <div className="d-flex justify-content-center">
            <form onSubmit={handleSubmit} className="auth-form mt-4">
              {isValidForm && (
                <div className="text-danger">
                  <i className="fas fa-exclamation-circle" /> Incorrect
                  credentials provided
                </div>
              )}
              <div className="form-group">
                <Input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  aria-label="Email"
                  placeholder="Email"
                  onChange={setEmail}
                />
                <Input
                  type="password"
                  className="form-control"
                  id="password"
                  name="password"
                  aria-label="Password"
                  placeholder="Password"
                  onChange={setPassword}
                />
                <Input
                  type="current_employer"
                  className="form-control"
                  id="current_employer"
                  name="current_employer"
                  aria-label="Current Employer"
                  placeholder="Current Employer"
                  onChange={setCurrentEmployer}
                />
              </div>
              <div className="d-flex justify-content-between align-items-end flex-wrap">
                <div className="">
                  <span>Registered? </span>
                  <Link to="/login" className="link">
                    Sign In
                  </Link>
                </div>
                <button className="btn btn-primary mt-md-3">Sign Up</button>
              </div>
            </form>
          </div>
        </section>
      </Fragment>
    </main>
  );
}

export default Register;
